import { BASE_URL } from '../../../../../utils/config.base-url'

export const URL_ENDPOINT_PHONG_HOP = `${BASE_URL}/phong-hop`
export const PHONG_HOP_PREFIX_URL = '/phong-hop'
